import TitleCell from "./TitleCell";

export default TitleCell;
